import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';

import { IonicVue } from '@ionic/vue';

import PrimeVue from 'primevue/config';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';

/* Custom styles */
import './theme/styles.css';
import './theme/dh.css';

import i18n from './i18n';
import { getStaticData } from './js/staticDatas.js';
import {  generateURL, getConfig, updateConfigFromRemote/*, deleteStorageByVersion*/ } from './js/config.js';
import Storage from "@/js/storage";
//deleteStorageByVersion();
updateConfigFromRemote();

const app = createApp(App).use(i18n)
  .use(IonicVue)
  .use(store)
  .use(router)
  .use(PrimeVue, {
    unstyled: true
  });

app.config.globalProperties.staticData = getStaticData();
app.config.globalProperties.APIURL = generateURL;
app.config.globalProperties.config = getConfig();


const startApp = async () => {
    await Storage.init();
    router.isReady().then(() => {
        try {
            const raw = localStorage.getItem('resumeAfterCamera');
            if (raw) {
                localStorage.removeItem('resumeAfterCamera');
                const marker = JSON.parse(raw);
                if (marker && marker.path && (Date.now() - marker.ts) < 5 * 60 * 1000) {
                    router.replace(marker.path);
                }
            }
        } catch (e) { /* ignore malformed marker */ }
        app.mount('#app');
    });
}

startApp()